import { FitFinder } from "@/components/FitToolAndSizeChart/components/FitFinder/FitFinder";
import { SizeChart } from "@/components/FitToolAndSizeChart/components/SizeChart/SizeChart";
import { standardComponent } from "@/context/StandardPropsContext/StandardPropsContext";
import styles from "./FitToolAndSizeChart.module.scss";

export const FitToolAndSizeChart = standardComponent(
  "FitToolAndSizeChart",
  () => (
    <div
      className={styles.sizeAndFitWrapper}
      data-testid="fit-tool-and-size-chart"
      data-component="FitToolAndSizeChart"
    >
      <FitFinder />
      <div className={styles.sizeChartColumn}>
        <SizeChart />
      </div>
    </div>
  ),
);
